/*
MIT License

Copyright (c) 2023 Artem Churyukin

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

class psl_events{
	constructor(){
		this._evt_list=new Map();
	}
	on(name,clb,has){
		if(typeof(name)==='object'){
			for(let item of Object.entries(name)) this.on(...item,has);
			return;
		}
		if(has) if(this._has_clb(name,clb)) return;
		if(!this._evt_list.has(name)) this._evt_list.set(name,new Set());
		this._evt_list.get(name).add(clb);
	}
	_has_clb(name,clb){
		if(!this._evt_list.has(name)) return false;
		return this._evt_list.get(name).has(clb);
	}
	clear(){
		this._evt_list=new Map();
	}
	once(name,clb){
		if(typeof(name)==='object'){
			for(let item of Object.entries(name)) this.once(...item);
			return;
		}
		clb.once=true;
		this.on(name,clb);
	}
	emit(name,args=[]){
		if(!this._evt_list.has(name)) return;
		for (let clb of this._evt_list.get(name).values()){
			clb(...args);
			if(clb.once) this.remove(name,clb);
		}
	}
	remove(name,clb){
		if(typeof(name)==='object'){
			for(let item of Object.entries(name)) this.remove(...item);
			return;
		}
		if(!this._evt_list.has(name)) return;
		this._evt_list.get(name).delete(clb);
	}
}
	
class sub_events{
	constructor(){
		this._events=new psl_events();
	}
	
	get events(){return this._events}
	set events(_){}
}

const singletone=new psl_events();
singletone.class=psl_events;
singletone.sub_events_class=sub_events;

export default singletone;
